export default function keyHash(o) {
    return (
        o &&
        Object.entries(o)
            .map(([prop, value]) => prop + (value && typeof value === 'object' ? `[${keyHash(value)}]` : value))
            .join(',')
    );
}
